import AxiosInstance from "./axiosInstance";

export const importData = (files) => {
  const formData = new FormData();
  Object.entries(files).forEach(([key, value]) => {
    formData.append(key, value?.file);
  });
  return AxiosInstance.post("/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    maxBodyLength: Infinity,
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const importStatus = () => {
  return AxiosInstance.get("/import/status")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
